import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { DEFAULT_TENANT_ID } from "@cop/domain";

const env = import.meta.env;

export const app = initializeApp({
  apiKey: env.VITE_FIREBASE_API_KEY ?? "demo-key",
  authDomain: env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: env.VITE_FIREBASE_PROJECT_ID ?? "demo-cop",
  appId: env.VITE_FIREBASE_APP_ID,
});
export const auth = getAuth(app);
export const db = getFirestore(app);

export const TENANT = DEFAULT_TENANT_ID;

const API_URL = (env.VITE_API_URL ?? "").replace(/\/$/, "");

export class ApiError extends Error {
  constructor(readonly code: string, message: string, readonly details?: Record<string, unknown>) {
    super(message);
  }
}

export function callable<I, O>(name: string) {
  return async (data: I): Promise<O> => {
    const token = await auth.currentUser?.getIdToken();
    let res: Response;
    try {
      res = await fetch(`${API_URL}/${name}`, {
        method: "POST",
        headers: { "content-type": "application/json", ...(token ? { authorization: `Bearer ${token}` } : {}) },
        body: JSON.stringify({ data }),
      });
    } catch {
      throw new ApiError("unavailable", "");
    }
    const body = (await res.json().catch(() => ({}))) as { result?: O; error?: { status: string; message: string; details?: Record<string, unknown> } };
    if (!res.ok || body.error) throw new ApiError(body.error?.status ?? "internal", body.error?.message ?? "", body.error?.details);
    return body.result as O;
  };
}

export function errorMessage(err: unknown) {
  const e = err as { code?: string; message?: string };
  if (e?.code === "unavailable" || (e?.code === "internal" && !e.message)) return "Sin conexión con el servidor. Reintentá.";
  return e?.message ?? "Algo salió mal.";
}
